const Color = {
  premiumBlack: '#0B0907',
  graphiteGrey: '#313131',
  metalGrey: '#95949D',
  graphicGrey: '#F0F0F0',
  backgroundGrey: '#F9F9FA',
  headerGrey: '#f2f2f2c9',

  darkRefinedGreen: '#547C75',
  refinedGreen: '#88B3B1',
  lightRefinedGreen: '#BED7D5',
  darkRed: '#BA5555',
  soothingPink: '#EFA5A5',
  lightPink: '#FFD3D3',
  lighterPink: '#FFEFEF',

  coffee: '#8A6A4E',
  modifiedGrey: '#A99E97',
  collCopper: '#EEC49C',
  lighterCopper: '#FFF4EA',
  titaniumWhite: '#FEF8F2',
  simplyWhite: '#FFFFFF',

  darkerBlue: '#246296',
  darkGreyBlue: '#5489B6',
  greyBlue: '#8EB2D0',
  lightGreyBlue: '#BBD6ED',
  selectedBlue: '#EDF7FF',
  calmGrey: '#DAD9DE',
  sleepingGrey: '#F3F5F8',

  transparent: 'transparent',

  //Default colors of the color scheme
  red: '#E54E4B',
  blue: '#5489B6',
  orange: '#f2a155',
  yellow: '#ede175',
  purple: '#eb5feba1',
  green: '#84C1A0',
  white: '#FFFFFF',
}

export const ColorGroups = [
  ['premiumBlack', 'graphiteGrey', 'metalGrey', 'graphicGrey', 'backgroundGrey'],
  ['darkRefinedGreen', 'refinedGreen', 'lightRefinedGreen', 'darkRed', 'soothingPink', 'lightPink'],
  ['coffee', 'modifiedGrey', 'collCopper', 'titaniumWhite', 'simplyWhite'],
  ['darkerBlue', 'darkGreyBlue', 'greyBlue', 'lightGreyBlue', 'selectedBlue', 'calmGrey', 'sleepingGrey'],
]

export default Color
